// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__i828F","create-modal":"styles_create-modal__Y93Z5"};